export const FormatDate = (dateString) => {
    // Guard empty/null/invalid inputs so unset date fields render "-" instead
    // of "NaN/NaN/NaN" (empty string) or "01/01/1970" (null -> Unix epoch).
    if (!dateString) return "-"
    const date = new Date(dateString)
    if (isNaN(date.getTime())) return "-"
    const day = date.getDate().toString().padStart(2, "0")
    const month = (date.getMonth() + 1).toString().padStart(2, "0")
    const year = date.getFullYear()
    return `${day}/${month}/${year}`
}